// extracted by mini-css-extract-plugin
export var appStores = "Z_dJ";
export var grey = "Z_dK";
export var icon = "Z_bw";
export var iconGroup = "Z_dH";
export var image = "Z_d";
export var left = "Z_bS";
export var reverse = "Z_dG";
export var right = "Z_bV";
export var section = "Z_b";
export var textSection = "Z_dF";